import styled from 'styled-components';
import { COLOR } from '@src/styles/color';
import BgCreditUsageGuide from '@src/assets/images/bg-credit-usage-guide.svg';

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  // adjacent sibling selector to add spacing between direct children, except for the first one
  > * + * {
    margin-top: ${({ $isMobile }) => ($isMobile ? '16px' : '24px')};
  }

  > .new-credit-intro-tabs-wrapper + * {
    margin-top: 16px;
  }
`;

export const StyledBanner = styled.div`
  position: relative;
  width: 100%;
  height: ${({ $isMobile }) => ($isMobile ? '112px' : '180px')};
  border-radius: ${({ $isMobile }) => ($isMobile ? '12px' : '16px')};
  border: ${({ $isMobile }) =>
    $isMobile
      ? `0.5px solid ${COLOR.functionalPink[16]}`
      : `0.5px solid ${COLOR.indigo[16]}`};
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${COLOR.white};
  ${({ $isMobile }) =>
    $isMobile
      ? `
      background-image: linear-gradient(
        135deg,
        rgba(255, 245, 247, 1) 0%,
        rgba(255, 255, 255, 1) 50%,
        rgba(255, 240, 230, 1) 100%
      );
      `
      : `
      background-image: url(${BgCreditUsageGuide});
      background-repeat: no-repeat;
      background-position: right center;
      background-size: cover;
      `};

  .banner-text-container {
    position: relative;
    z-index: 1;
    ${({ $isMobile }) =>
      $isMobile
        ? `
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
        padding: 12px;
        height: 100%;
        box-sizing: border-box;
      `
        : `
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 24px;
        width: 513px;
        box-sizing: border-box;
      `};
  }

  .banner-sparkle {
    display: ${({ $isMobile }) => ($isMobile ? 'block' : 'none')};
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: ${COLOR.functionalPink.default};
  }

  .banner-text-column {
    display: flex;
    flex-direction: column;
    gap: ${({ $isMobile }) => ($isMobile ? '4px' : '8px')};
    flex: 1;
    min-width: 0;
  }

  .banner-title {
    margin: 0;
    font-weight: ${({ $isMobile }) => ($isMobile ? '600' : '700')};
    font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '24px')};
    line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '32px')};
    letter-spacing: -0.4px;
    color: ${COLOR.label2[100]};
  }

  .banner-paragraph {
    margin: 0;
    font-weight: 400;
    font-size: ${({ $isMobile }) => ($isMobile ? '10px' : '14px')};
    line-height: ${({ $isMobile }) => ($isMobile ? '16px' : '20px')};
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
    max-width: 100%;

    b {
      font-weight: ${({ $isMobile }) => ($isMobile ? '700' : '500')};
      color: ${COLOR.label2[100]};
    }
  }

  .banner-paragraph--emphasis {
    b {
      font-weight: ${({ $isMobile }) => ($isMobile ? '700' : '600')};
    }
  }
`;

export const TABS_STYLE = {
  backgroundColor: COLOR.charcoal,
  border: `0.5px solid ${COLOR.indigo[16]}`,
  borderRadius: '12px',
  padding: '4px',
  gap: '0',
  boxSizing: 'border-box',
};

export const getTabItemStyle = (isMobile) => ({
  padding: '8px 24px',
  borderRadius: '8px',
  color: isMobile ? COLOR.label2[48] : COLOR.label2[64],
  backgroundColor: 'transparent',
  activeBackgroundColor: COLOR.white,
  activeColor: COLOR.label2[100],
  activeBorderRadius: '8px',
});

export const StyledTabsWrapper = styled.div`
  width: ${({ $isMobile }) => ($isMobile ? '100%' : 'fit-content')};

  .new-credit-intro-tabs {
    width: ${({ $isMobile }) => ($isMobile ? '100%' : 'fit-content')};
    & > * {
      flex: ${({ $isMobile }) => ($isMobile ? '1' : 'none')};
      min-width: ${({ $isMobile }) => ($isMobile ? 'auto' : '120px')};
      height: 40px;
      justify-content: center;
      letter-spacing: -0.4px;
      box-sizing: border-box;

      &.active {
        box-shadow: 0px 2px 16px 0px ${COLOR.black[8]};
      }
    }
  }
`;
